<!-- 资管策略 -->
<template>
  <div class="container">
    <Banner />
    <div class="flex-sb filter">
      <div class="signals">信号</div>
      <div class="flex-sb">
        <div class="filter-item" @click="order1(this.total_profit_loss = !this.total_profit_loss)">
          总盈亏
          <img
            v-if="this.ordering == 'total_profit_loss'"
            class="rotated-image"
            src="@/assets/images/components/arrow.png"
          />
          <img
            v-else-if="this.ordering == '-total_profit_loss'"
            src="@/assets/images/components/arrow.png"
          />
          <img v-else src="@/assets/images/components/arrow1.png" />
        </div>
        <div class="filter-item" @click="order2(this.return_rate = !this.return_rate)">
          收益率
          <img
            v-if="this.ordering == 'return_rate'"
            class="rotated-image"
            src="@/assets/images/components/arrow.png"
          />
          <img
            v-else-if="this.ordering == '-return_rate'"
            src="@/assets/images/components/arrow.png"
          />
          <img v-else src="@/assets/images/components/arrow1.png" />
        </div>
        <div class="filter-item" @click="order3(this.accuracy = !this.accuracy)">
          准确率
          <img
            v-if="this.ordering == 'accuracy'"
            class="rotated-image"
            src="@/assets/images/components/arrow.png"
          />
          <img v-else-if="this.ordering == '-accuracy'" src="@/assets/images/components/arrow.png" />
          <img v-else src="@/assets/images/components/arrow1.png" />
        </div>
        <div class="filter-item" @click="order4(this.max_drawdown = !this.max_drawdown)">
          最大回撤
          <img
            v-if="this.ordering == 'max_drawdown'"
            class="rotated-image"
            src="@/assets/images/components/arrow.png"
          />
          <img
            v-else-if="this.ordering == '-max_drawdown'"
            src="@/assets/images/components/arrow.png"
          />
          <img v-else src="@/assets/images/components/arrow1.png" />
        </div>
      </div>
      <div class="flex-sb">
        <input
          v-model="search_key"
          @blur="searchKey()"
          type="text"
          placeholder="请输入关键词搜索"
          class="input_search"
        />
        <el-icon class="search_icon" color="#7E7F83" size="14">
          <Search />
        </el-icon>
      </div>
      <div style="width: 64px;"></div>
    </div>

    <div v-for="(item, index) in strategyList" :key="index">
      <div class="strategy_List">
        <div class="strategy_name" @click="toggle(index, item.strategy_id, item.k_id)">
          <div class="strategy_name_top">
            <div class="flex">
              <div class="signal_avatar">
                <img :src="baseUrl + 'api' + item.company.avatar" />
              </div>

              <div>
                <div class="strategy_name">{{ item.company.name }}</div>
                <div class="strategy_server">{{ item.accuracy }}</div>
              </div>
            </div>
          </div>
          <div class="strategy_name_bottom">
            <div class="strategy_name">{{ item.strategy_name }}</div>
            <div>策略介绍：{{ item.introduction }}</div>
          </div>
        </div>
        <div class="strategy_data flex-sb">
          <div class="strategy-item">
            <div
              :class="[item.total_profit_loss >= 0 ? 'fall' : 'rise', 'strategy-items']"
            >{{ '$' + item.total_profit_loss }}</div>
          </div>
          <div class="strategy-item">
            <div
              :class="[item.return_rate >= 0 ? 'fall' : 'rise', 'strategy-items']"
            >{{ item.return_rate }}</div>
          </div>
          <div class="strategy-item">{{ item.accuracy }}</div>
          <div class="strategy-item">{{ item.max_drawdown }}</div>
        </div>
        <div class="strategy_ercharts">
          <div class="strategy_ercharts1">
            <MyLineChart :data="item.data" />
          </div>
          <!-- <img class="strategy_ercharts1" :src="item.picture" /> -->
        </div>
        <div class="sharebtn" @click="copyText()">
          <img class="shareimg" src="../../assets/images/components/share.png" alt />分享
        </div>
      </div>
      <div>
        <div v-show="activeIndex === index" class="show_strategys">
          <el-row :gutter="20" class="mt-16">
            <el-col :span="15">
              <div class="incomeBox strategy-item-Box padding-16">
                <div class="flex-sb">
                  <div class="strategy-title">
                    收益
                    <!-- <span class="strategy-title1">(月收益)</span> -->
                  </div>
                  <div class="flex">
                    <div
                      v-for="(tab, index) in income_tabs"
                      :key="index"
                      @click="incomeIndex_change(index)"
                      :class="[activeIndex_income == index ? 'income_tabs_active' : 'income_tabs']"
                    >{{ tab }}</div>
                    <div class="amplifyBox">
                      <img class="amplify" src="@/assets/images/components/amplify.png" alt />
                    </div>
                  </div>
                </div>
                <div class="tab-content">
                  <div class="flex-center" v-if="activeIndex_income == 0">
                    <PtofitCharts v-if="_isshow11" :data="profitData" />
                  </div>
                  <div class="flex-center" v-if="activeIndex_income == 1">
                    <PtofitCharts v-if="_isshow11" :data="profitData1" />
                  </div>
                  <div class="flex-center" v-if="activeIndex_income == 2">
                    <PtofitCharts v-if="_isshow11" :data="profitData2" />
                  </div>
                  <div class="flex-center" v-if="activeIndex_income == 3">
                    <PtofitCharts v-if="_isshow11" :data="profitData3" />
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="9">
              <div class="varietyBox strategy-item-Box padding-16">
                <div class="flex-sb">
                  <div class="strategy-title">品种偏好</div>
                  <div>
                    <img class="amplify" src="@/assets/images/components/amplify.png" alt />
                  </div>
                </div>
                <div class="flex-center">
                  <PieChart v-if="pieData.length!=0" :data="pieData" />
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="mt-16">
            <el-col :span="12">
              <div class="incomeBox strategy-item-Box padding-16">
                <div class="flex-sb">
                  <div class="strategy-title">资金曲线</div>
                  <div class="flex">
                    <div
                      v-for="(tab, index) in income_tabs"
                      :key="index"
                      @click="incomeIndex_change(index)"
                      :class="[activeIndex_income == index ? 'income_tabs_active' : 'income_tabs']"
                    >
                      {{ tab }}
                      <!-- <div :class="[ activeIndex_income = index?'income_tabs_active':'income_tabs']"></div> -->
                    </div>
                    <div class="amplifyBox">
                      <img class="amplify" src="@/assets/images/components/amplify.png" alt />
                    </div>
                  </div>
                </div>
                <div class="tab-content">
                  <div v-if="activeIndex_income === 0" class="flex-center">
                    <LineCharts v-if="_isshow11" :data="LineData" />
                  </div>
                  <div v-if="activeIndex_income === 1" class="flex-center">
                    <LineCharts v-if="_isshow11" :data="LineData1" />
                  </div>
                  <div v-if="activeIndex_income === 2" class="flex-center">
                    <LineCharts v-if="_isshow11" :data="LineData2" />
                  </div>
                  <div v-if="activeIndex_income === 3" class="flex-center">
                    <LineCharts v-if="_isshow11" :data="LineData3" />
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="incomeBox strategy-item-Box padding-16">
                <div class="flex-sb">
                  <div class="strategy-title">账户利润</div>
                  <div class="flex">
                    <div
                      v-for="(tab, index) in income_tabs"
                      :key="index"
                      @click="incomeIndex_change(index)"
                      :class="[activeIndex_income == index ? 'income_tabs_active' : 'income_tabs']"
                    >{{ tab }}</div>
                    <div class="amplifyBox">
                      <img class="amplify" src="@/assets/images/components/amplify.png" alt />
                    </div>
                  </div>
                </div>
                <div class="tab-content">
                  <div v-if="activeIndex_income === 0" class="flex-center">
                    <LineCharts1 v-if="_isshow11" :data="profitData" />
                  </div>
                  <div v-if="activeIndex_income === 1" class="flex-center">
                    <LineCharts1 v-if="_isshow11" :data="profitData1" />
                  </div>
                  <div v-if="activeIndex_income === 2" class="flex-center">
                    <LineCharts1 v-if="_isshow11" :data="profitData2" />
                  </div>
                  <div v-if="activeIndex_income === 3" class="flex-center">
                    <LineCharts1 v-if="_isshow11" :data="profitData3" />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="mt-16 padding-16 tradeBox">
            <div class="flex-sb">
              <div class="strategy-title">交易统计管理模块</div>
              <div>
                <div class="flex">
                  <div
                    v-for="(tab, index) in trade_tabs"
                    :key="index"
                    @click="tradeIndex_change(index)"
                    :class="[ activeIndex_trade == index?'income_tabs_active':'income_tabs']"
                  >{{ tab }}</div>
                </div>
              </div>
            </div>
            <div class="trade_tableBox mt-16">
              <table>
                <thead>
                  <tr>
                    <th>编号</th>
                    <th>日期</th>
                    <th>单量</th>
                    <th>手数</th>
                    <th>盈亏</th>
                    <th>盈亏比</th>
                    <th>余额</th>
                    <th>出入金</th>
                    <!-- <th>最大浮亏</th> -->
                    <th>累计盈亏</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in tradeList" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{ item.trade_date }}</td>
                    <td>{{ item.trade_times }}</td>
                    <td>{{ item.volume }}</td>
                    <td>
                      <div
                        :class="[ item.profit>0?'fall-color':'rise-color','fw-700']"
                      >{{ item.profit}}</div>
                    </td>
                    <td>
                      <div
                        :class="[ item.period_roi>0?'fall-color':'rise-color','fw-700']"
                      >{{ (parseFloat(item.period_roi)*100).toFixed(2)}}%</div>
                    </td>
                    <td>
                      <div
                        :class="[ item.balance>0?'fall-color':'rise-color','fw-700']"
                      >{{ item.balance }}</div>
                    </td>
                    <td>
                      <div
                        :class="[ item.amount>0?'fall-color':'rise-color','fw-700']"
                      >{{ item.amount }}</div>
                    </td>
                    <td>
                      <div
                        :class="[ item.total_profit>0?'fall-color':'rise-color','fw-700']"
                      >{{ item.total_profit }}</div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="mt-16 padding-16 orderBox">
            <div class="flex">
              <div
                @click="orderIndex = 0"
                :class="[orderIndex == 0 ? 'order_active' : 'order']"
              >历史订单</div>
              <div
                @click="orderIndex = 1"
                :class="[orderIndex == 1 ? 'order_active' : 'order']"
              >持仓订单</div>
            </div>
            <div class="trade_tableBox mt-16">
              <div v-if="this.orderIndex == 0 && historyList.length != 0">
                <table>
                  <thead>
                    <tr>
                      <th>品种</th>
                      <th>类型</th>
                      <th>手数</th>
                      <th>开仓价格</th>
                      <th>开仓时间</th>
                      <th>平仓时间</th>
                      <th>盈亏</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in historyList" :key="index">
                      <td>{{ item.symbol }}</td>
                      <td>{{ item.trade_type }}</td>
                      <td>{{ item.volume }}</td>
                      <td>{{ item.open_price }}</td>
                      <td width="200px">{{ formatDate(item.open_time) }}</td>
                      <td width="200px">{{ formatDate(item.close_time) }}</td>
                      <td>{{ item.profit }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="pagination">
                  <el-pagination
                    background
                    layout="  prev, pager, next, jumper"
                    :current-page="hcurrentPage"
                    :page-size="hpageSize"
                    @current-change="hhandleCurrentChange"
                    :total="htotal"
                  />
                </div>
              </div>

              <!-- PositionList -->
              <div v-if="this.orderIndex == 1 && PositionList.length != 0">
                <table>
                  <thead>
                    <tr>
                      <th>品种</th>
                      <th>类型</th>
                      <th>手数</th>
                      <th>开仓价格</th>
                      <th>开仓时间</th>
                      <!-- <th>平仓时间</th> -->
                      <th>盈亏</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in PositionList" :key="index">
                      <td>{{ item.symbol }}</td>
                      <td>{{ item.trade_type }}</td>
                      <td>{{ item.volume }}</td>
                      <td>{{ item.open_price }}</td>
                      <td width="200px">{{ formatDate(item.open_time) }}</td>
                      <!-- <td width="200px">{{ formatDate(item.close_time) }}</td> -->
                      <td>{{ item.profit }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div @click="isretract()" class="flex-center isretract">
                <img class="isretractimg" src="../../assets/images/components/toparrow.png" />收起全部数据
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import PtofitCharts from "./components/profitCharts.vue";
import PieChart from "./components/PieChart.vue";
import LineCharts from "./components/LineCharts.vue";
import LineCharts1 from "./components/LineCharts1.vue";
import MyLineChart from "@/components/MyLineChart.vue";
import moment from "moment";
import { ElMessage } from "element-plus";
import axios from "axios";

import {
  getStrategy,
  getStrategydetails,
  getStrategyhistory,
  getStrategypie,
  getStrategyreturnrate,
  getStrategybalance,
  getStrategydrawdown,
  getPositionorders,
  getPositionorders1,
  follower_p_data,
  follower_c_data,
  manage_get_history,
  synctoken
} from "@/api/api.js";
import Banner from "@/views/layout/components/banner.vue";
import { getToken, setToken } from "@/utils/store";
export default {
  components: {
    PtofitCharts,
    MyLineChart,
    PieChart,
    LineCharts1,
    LineCharts,
    Banner
  },
  data() {
    return {
      search_key: "",
      strategyList: [],
      _isshow11: false,
      pieData: [],
      activeIndex: null,
      activeIndex_income: 3,
      income_tabs: ["月", "季", "1年", "全部"],
      range: ["month", "quarter", "year", "all"],
      raterange: "year",
      profitData: [],
      profitData1: [],
      profitData2: [],
      profitData3: [],
      LineData: [],
      LineData1: [],
      LineData2: [],
      LineData3: [],
      NetworthData: [],
      NetworthData1: [],
      NetworthData2: [],
      NetworthData3: [],
      activeIndex_trade: 3,
      trade_tabs: ["日", "周", "月", "年"],
      range1: ["D", "W", "M", "Y"],
      traderange: "Y",
      contents: [30, 360, 6, 6],
      tradeList: [],
      historyList: [], //历史订单
      PositionList: [], //持仓订单
      orderIndex: 0,
      // 排序
      total_profit_loss: false,
      return_rate: false,
      accuracy: false,
      max_drawdown: false,
      id: 1, //当前策略id
      ordering: "",
      total: 10, //总条数
      pageSize: 10, //每页条数
      currentPage: 1, //当前页
      htotal: 10, //总条数
      hpageSize: 10, //每页条数
      hcurrentPage: 1, //当前页
      baseUrl: "",
      strategytoken: ""
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 请求token单独的
    async handleSubmit() {
      await synctoken({})
        .then(res => {
          setToken("token1", res.token);
        })
        .catch(err => {});
    },
    isretract() {
      this.activeIndex = null;
    },
    // 复制
    copyText() {
      var oInput = document.createElement("input");
      oInput.value = this.baseUrl;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      ElMessage({
        message: "网站链接已复制!",
        type: "success"
      });
    },
    // 转化时间格式
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    searchKey() {
      this.getStrategyList();
    },
    toggle(index, id, k_id) {
      this._isshow11 = false;
      this.id = id;
      this.k_id = k_id;
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
      // 策略详情交易模块，暂且注释
      this.getmanageList();
      this.getStrategybalances();
      this.getPList();
      this.getHistoryList();
      // 品种偏好
      getStrategypie(k_id)
        .then(res => {
          this.pieData = res.results.summary;
        })
        .catch(err => {});
    },

    getStrategybalances() {
      if (this.activeIndex_income == 0) {
        getStrategybalance({
          account: this.k_id,
          days: "30"
        })
          .then(res => {
            this.LineData = res.results.history_chart_data;
            this.NetworthData = res.results.history_chart_data;
            this.profitData = res.results.history_chart_data;
            this._isshow11 = true;
          })
          .catch(err => {});
      } else if (this.activeIndex_income == 1) {
        getStrategybalance({
          account: this.k_id,
          days: "90"
        })
          .then(res => {
            this.LineData1 = res.results.history_chart_data;
            this.NetworthData1 = res.results.history_chart_data;
            this.profitData1 = res.results.history_chart_data;
            this._isshow11 = true;
          })
          .catch(err => {});
      } else if (this.activeIndex_income == 2) {
        getStrategybalance({
          account: this.k_id,
          days: "180"
        })
          .then(res => {
            this.LineData2 = res.results.history_chart_data;
            this.NetworthData2 = res.results.history_chart_data;
            this.profitData2 = res.results.history_chart_data;
            this._isshow11 = true;
          })
          .catch(err => {});
      } else if (this.activeIndex_income == 3) {
        getStrategybalance({
          account: this.k_id,
          days: "1095"
        })
          .then(res => {
            this.LineData3 = res.results.history_chart_data;
            this.NetworthData3 = res.results.history_chart_data;
            this.profitData3 = res.results.history_chart_data;
            this._isshow11 = true;
          })
          .catch(err => {});
      }
    },
    incomeIndex_change(index) {
      this.activeIndex_income = index;
      this.raterange = this.range[index];
      this.getStrategybalances();
    },
    tradeIndex_change(index) {
      this.activeIndex_trade = index;
      this.traderange = this.range1[index];

      this.getmanageList();
    },

    // 历史订单
    getHistoryList() {
      follower_p_data({
        account: this.k_id,
        page: this.hcurrentPage
        // ordering: "",
        // status: "",
        // ticket: ""
      })
        .then(res => {
          if (res.data.results.length != 0) {
            this.historyList = res.data.results;
          }
        })
        .catch(err => {});
    },
    // 平仓订单
    getPList() {
      follower_c_data({
        account: this.k_id
      })
        .then(res => {
          if (res.data.results.length != 0) {
            this.PositionList = res.data.results;
          }
        })
        .catch(err => {
          // this.close_loading = false
        });
    },
    // 交易管理模块
    getmanageList() {
      manage_get_history({
        account: this.k_id,
        period: this.traderange
      })
        .then(res => {
          console.log(res.data.results);

          this.tradeList = res.data.results;
        })
        .catch(err => {
          // this.close_loading = false
        });
    },
    // 获取策略列表
    getStrategyList() {
      getStrategy({
        ordering: this.ordering,
        page: this.currentPage,
        search: this.search_key
      })
        .then(res => {
          this.strategyList = res.results;
          this.total = res.count;
        })
        .catch(err => {});
    },
    // 排序
    order1(value) {
      (this.accuracy = false),
        (this.max_drawdown = false),
        (this.return_rate = false),
        value
          ? (this.ordering = "total_profit_loss")
          : (this.ordering = "-total_profit_loss");
      this.getStrategyList();
    },
    order2(value) {
      (this.total_profit_loss = false),
        (this.max_drawdown = false),
        (this.accuracy = false),
        value
          ? (this.ordering = "return_rate")
          : (this.ordering = "-return_rate");
      this.getStrategyList();
    },
    order3(value) {
      (this.total_profit_loss = false),
        (this.max_drawdown = false),
        (this.return_rate = false),
        value ? (this.ordering = "accuracy") : (this.ordering = "-accuracy");
      this.getStrategyList();
    },
    order4(value) {
      (this.total_profit_loss = false),
        (this.accuracy = false),
        (this.return_rate = false),
        value
          ? (this.ordering = "max_drawdown")
          : (this.ordering = "-max_drawdown");
      this.getStrategyList();
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getStrategyList();
    },
    hhandleCurrentChange(val) {
      this.hcurrentPage = val;
      this.getHistoryList();
    }
  },
  created() {},
  mounted() {
    this.baseUrl = window.location.href;
    this.handleSubmit();
    this.getStrategyList();
  }
};
</script>
<style lang='css' scoped>
@import "./style/strategy.css";
</style>